import { ProductPlaceholder } from '../enums/placeholder';
import { HtmlId } from '../enums/elementId';
import { ITooltipProperties, Tooltip, createTooltip } from '@vfde-brix/ws10/tooltip';
import { getCMSConfig } from '../util/cms';
import { getTooltipProps } from '../util/components/tooltipHelper';
import { mountComponent } from '../util/mount';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';
import { addTooltipTracking } from '../util/tracking';
import { replaceAllPlaceholders } from '../util/formatter';

export const mountToolTip = (wrapperId: HtmlId, props?: ITooltipProperties) => {
    const tooltip: Tooltip | undefined = mountComponent(
        wrapperId,
        createTooltip,
        props || NO_PATTERN_BUSINESS_LOGIC
    );

    tooltip && addTooltipTracking(tooltip.getContainerElement());

    return tooltip;
};

export const mountPriceSublineTooltip = (wrapperId: HtmlId) =>
    mountToolTip(wrapperId, getTooltipProps(wrapperId, getCMSConfig()?.tariffDetails?.tooltip));

export const mountFormSublineTooltip = (wrapperId: HtmlId) =>
    mountToolTip(wrapperId, getTooltipProps(wrapperId, getCMSConfig()?.avcTooltip));

export const mountPriceInstallationTextTooltip = (wrapperId: HtmlId, installationFee: number) => {
    const tooltipConfig = getCMSConfig().offerSummaryCard.legalText.installationPriceLine.tooltip;

    mountToolTip(wrapperId, getTooltipProps(wrapperId, {
        text: replaceAllPlaceholders(tooltipConfig?.text, {
            [ProductPlaceholder.INSTALLATION_FEE]: installationFee.toString(),
        }),
    }));
};
